import { deviceTypes, TaskQL, Task } from './../../providers/tasks/models';
import { TasksProvider } from './../../providers/tasks/tasks';
import { UtilsProvider } from './../../providers/utils/utils';
import { TasksPage } from './../tasks/tasks';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  Platform,
  AlertController
} from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { ENV } from '../../environments/environment';

@IonicPage()
@Component({
  selector: 'page-task-cancel',
  templateUrl: 'task-cancel.html'
})
export class TaskCancelPage {
  private task: TaskQL;
  private extras: any;
  private customer: any;
  private message: string = '';
  private ready: boolean;
  private reason: string = '';
  private loading: boolean = false;
  cancelReason: string = '';
  filteredReasons: Array<any>
  private cancellationReasons: Array<any> = [
    {
      name: 'Customer not reachable',
      value: 'Customer not reachable',
    },
    {
      name: 'Customer no longer interested',
      value: 'Customer no longer interested'
    },
    {
      name: 'Non-compliant geyser - No Drip Tray',
      value: 'Non-compliant geyser - No Drip Tray',
      taskTypes: ['installation', 'repair'],
      deviceTypes: ['geyser']
    },
    {
      name: 'Non-compliant geyser - Piping/Safety Valves',
      value: 'Non-compliant geyser - Piping/Safety Valves',
      taskTypes: ['installation', 'repair'],
      deviceTypes: ['geyser']
    },
    {
      name: 'Non-compliant geyser - Geyser Outside/Wall-Hung/Inaccessible',
      value: 'Non-compliant geyser - Geyser Outside/Wall-Hung/Inaccessible',
      deviceTypes: ['geyser']
    },
    {
      name: 'Non-compliant geyser - Solar/Heat Pump/Gas Geyser',
      value: 'Non-compliant geyser - Solar/Heat Pump/Gas Geyser',
      taskTypes: ['installation'],
      deviceTypes: ['geyser']
    },
    {
      name: 'Non-compliant geyser - Electrical/Element/Wiring Issue',
      value: 'Non-compliant geyser - Electrical/Element/Wiring Issue',
      taskTypes: ['installation', 'repair'],
      deviceTypes: ['geyser']
    },
    {
      name: 'Non-compliant geyser - Ripple Relay/Timer Installed',
      value: 'Non-compliant geyser - Ripple Relay/Timer Installed',
      taskTypes: ['installation', 'repair'],
      deviceTypes: ['geyser']
    },
    {
      name: 'Non-compliant geyser - Burst/Damaged Geyser',
      value: 'Non-compliant geyser - Burst/Damaged Geyser',
      taskTypes: ['installation', 'repair'],
      deviceTypes: ['geyser']
    },
    {
      name: 'Other - Free text allowed',
      value: 'Other'
    }
  ];

  private images: Array<any> = new Array(0);
  private attachments: Array<any> = new Array();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private camera: Camera,
    private platform: Platform,
    private alertCtrl: AlertController,
    private utilsProvider: UtilsProvider,
    private tasksProvider: TasksProvider
  ) {
    this.task = this.navParams.get('task');
    this.customer = this.navParams.get('customer');
    this.extras = this.navParams.get('extras');
    this.filterCancelationReasons();
  }

  ionViewDidLoad() {}

  addPhoto() {
    // adding photo
    this.images.push(null);
  }
  hasImages() {
    return this.images && this.images.length > 0 && this.images[0] !== null;
  }
  readyCheck() {
    let flag = true;
    for (let i = 0; i < 4; i++) {
      if (!this.images[i]) {
        flag = false;
      }
    }
    //if(this.images.length == 0)
    this.ready = flag;
  }
  removeImage(index) {
    this.images[index] = null;
    this.readyCheck();
  }
  addImage(index, source = 1) {
    const options: CameraOptions = {
      quality: 75,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 1200,
      targetHeight: 900,
      correctOrientation: true,
      sourceType: source //Camera=1, PhotoLibrary=0, SavedPhotoAlbum=2
    };

    if (!this.platform.is('cordova') && ENV.base.includes("dev")) {
      this.utilsProvider.toDataURL('assets/img/sample.jpg').then(dataUrl => {
        let imageData = dataUrl
          .toString()
          .replace('data:image/jpeg;base64,', '');
        let base64Image = dataUrl;

        this.images[index] = imageData;
        this.readyCheck();
      });
    } else if (this.platform.is('cordova')) {
      this.camera.getPicture(options).then(
        imageData => {
          let base64Image = 'data:image/jpeg;base64,' + imageData;
          this.images[index] = imageData;
          this.readyCheck();
        },
        err => {
          this.images = this.cleanArray(this.images);
        }
      );
    }
  }
  addImageInput(event, index) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.utilsProvider.resizeImg(file).then(file => {
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.images[index] = reader.result.toString().split(',')[1];
            this.readyCheck();
          };
        }).catch(e => {
          console.log("Upload Error",e)
      })
    }
  }

  isCordova() {
    return this.platform.is('cordova');
  }

  chunk(arr, size) {
    var newArr = [];
    for (var i = 0; i < arr.length; i += size) {
      newArr.push(arr.slice(i, i + size));
    }
    return newArr;
  }
  cleanArray(actual) {
    var newArray = new Array();
    for (var i = 0; i < actual.length; i++) {
      if (actual[i] || i < 4) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }

 
  cancelTask() {
    this.loading = true;
    let reasonTxt = this.reason.length > 0 ? this.cancelReason + ' | ' + this.reason: this.cancelReason;
    this.images = this.cleanArray(this.images);
    if (this.images.length > 0) {
      const imgs = this.images.map(img => {
        return { data: img };
      });
      this.utilsProvider.uploadImages(imgs, 0, null, this.task.id).subscribe(
        response => {
          this.attachments.push(response.data.src);
        },
        error => {
          let message = 'Images could not be uploaded. Please try again.';
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message: message,
            buttons: ['OK']
          });
          alert.present();
        },
        () => {
          this.completeCancel(reasonTxt);
        }
      );
    } else {
      this.completeCancel(reasonTxt);
    }
  }

  completeCancel(reasonTxt: string) {
    this.tasksProvider
      .cancelTaskRest(this.task.id, reasonTxt, this.attachments, this.extras.hasNewSerial)
      .subscribe(
        data => {
          this.loading = true;
        },
        error => {
          let message = 'Task could not be cancelled, please try again later.';
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message: message,
            buttons: ['OK']
          });
          alert.present();
          this.loading = false;
        },
        () => {
          this.navCtrl.pop();
          this.navCtrl.pop();
        }
      );
  }

  disableCheck(){
    let trimmedReason = this.reason.trim();
    if(this.loading) return true;
    if(this.cancelReason.length < 1) return true;
    const typedReasonNeeded = this.cancelReason === 'Other';
    if(typedReasonNeeded && trimmedReason.length < 5) return true;

    if ((this.cancelReason !== "Customer not reachable") && 
        (this.cancelReason !== "Customer no longer interested") &&
        (this.cancelReason !== "Other")) {
      
      const getImages = this.images.filter(img => img !== null);
      if (getImages.length === 0) {
        return true;
      }
    }

    if(typedReasonNeeded && trimmedReason.length < 5) return true;
    return false;
  }

  filterCancelationReasons(){
    const taskDeviceType = this.task.deviceType;
    const taskType = this.task.type;
    this.filteredReasons = this.cancellationReasons.filter(reason => {
      if(reason.taskTypes){
        const foundTaskType = reason.taskTypes.indexOf(taskType);
        if(foundTaskType < 0) return false;
      }
      if(reason.deviceTypes){
        const foundDeviceType = reason.deviceTypes.indexOf(taskDeviceType);
        if(foundDeviceType < 0) return false;
      }
      return reason
    });

  }

  hasACancellationReason() {
    return this.cancelReason && this.cancelReason.length > 1
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-cancel/task-cancel.ts